export default __webpack_public_path__ + "static/media/falcor.507fbecd.svg";